import { __extends } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Http } from './utils/index.ts';
var CachableRequest = /*@__PURE__*/ (function () {
    function CachableRequest(promise) {
        this.onFinishCallbacks = [];
        this.promise = promise;
        this.start();
    }
    CachableRequest.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _i, _b, callback;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.promise()];
                    case 1:
                        _a.response = _c.sent();
                        if (this.onFinishCallbacks) {
                            for (_i = 0, _b = this.onFinishCallbacks; _i < _b.length; _i++) {
                                callback = _b[_i];
                                callback(this.response);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CachableRequest.prototype.onFinish = function (callback) {
        this.onFinishCallbacks.push(callback);
    };
    CachableRequest.prototype.getResponse = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.response) {
                resolve(_this.response);
            }
            else {
                _this.onFinish(function (response) {
                    resolve(response);
                });
            }
        });
    };
    return CachableRequest;
}());
export { CachableRequest };
export function Versioning() {
    function Factory(classType) {
        var _a;
        return _a = /** @class */ (function (_super) {
            __extends(VersionedRoute, _super);
            function VersionedRoute() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return VersionedRoute;
        }(classType)),
            _a.versioning = true,
            _a;
    }
    return Factory;
}
export function Route(endpoint, absolute, form) {
    function Factory(classType) {
        return /** @class */ (function (_super) {
            __extends(AbstractRoute, _super);
            function AbstractRoute() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            AbstractRoute.get = function (params) {
                return __awaiter(this, void 0, void 0, function () {
                    var networkCache, _a, _b;
                    var _this = this;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                networkCache = AbstractRoute.getNetworkCache();
                                if (!window.networkCache.get[endpoint]) {
                                    window.networkCache.get[endpoint] = new CachableRequest(function () {
                                        return __awaiter(_this, void 0, void 0, function () {
                                            var lastModified, lastModifiedDate, e_1;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        if (!this.versioning)
                                                            return [3 /*break*/, 4];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([1, 3, , 4]);
                                                        return [4 /*yield*/, Http.lastModified(endpoint, absolute)];
                                                    case 2:
                                                        lastModified = _a.sent();
                                                        lastModifiedDate = new Date(lastModified);
                                                        endpoint = endpoint.split('?')[0] + "?t=" + lastModifiedDate.getTime();
                                                        return [3 /*break*/, 4];
                                                    case 3:
                                                        e_1 = _a.sent();
                                                        console.log('Error while fetching last modification', e_1);
                                                        return [3 /*break*/, 4];
                                                    case 4: return [4 /*yield*/, Http.get(endpoint, params, absolute)];
                                                    case 5: return [2 /*return*/, _a.sent()];
                                                }
                                            });
                                        });
                                    });
                                }
                                _b = (_a = classType).get;
                                return [4 /*yield*/, window.networkCache.get[endpoint].getResponse()];
                            case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                        }
                    });
                });
            };
            AbstractRoute.post = function (params) {
                return __awaiter(this, void 0, void 0, function () {
                    var response, exception_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, Http.post(endpoint, params, absolute, form)];
                            case 1:
                                response = _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                exception_1 = _a.sent();
                                console.log(exception_1);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/, classType.post(response)];
                        }
                    });
                });
            };
            AbstractRoute.getNetworkCache = function () {
                if (!window.networkCache) {
                    window.networkCache = {
                        get: {},
                        post: {}
                    };
                }
                return window.networkCache;
            };
            return AbstractRoute;
        }(classType));
    }
    return Factory;
}



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/core/route.ts
// module id = null
// module chunks = 